/* Kids layout sections (kv-*): gallery, tabs, bundle tiers, video scroller and add to cart.
   Add to cart uses the theme's own cart drawer when it is on the page, otherwise goes to the cart. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  function tabs(root) {
    $$('.kv [data-tabs]', root).forEach(box => {
      if (!once(box, 'kvTabs')) return;
      $$('[data-tab]', box).forEach(tab => tab.addEventListener('click', () => {
        const i = tab.dataset.tab;
        $$('[data-tab]', box).forEach(t => { const on = t.dataset.tab === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
        $$('[data-panel]', box).forEach(p => { const on = p.dataset.panel === i; p.hidden = !on; p.classList.toggle('is-active', on); });
      }));
    });
  }

  function gallery(root) {
    $$('.kv [data-gallery]', root).forEach(g => {
      if (!once(g, 'kvGallery')) return;
      const slides = $$('[data-slide]', g), thumbs = $$('[data-thumb]', g);
      let cur = 0;
      const go = i => {
        cur = (i + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle('is-active', k === cur));
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === cur));
        const t = thumbs[cur]; if (t) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      };
      thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.thumb)));
      const p = $('[data-gallery-prev]', g), n = $('[data-gallery-next]', g);
      if (p) p.addEventListener('click', () => go(cur - 1));
      if (n) n.addEventListener('click', () => go(cur + 1));
      let sx = null; const stage = $('.mp__stage', g);
      if (stage) {
        stage.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
      }
    });
  }

  /* Bundle tiers: the tiers and the add-to-cart button can be separate blocks, so look across the whole section. */
  /* Bundle tiers: variant tiers ([data-tier]) and quantity tiers ([data-kq]) can sit in a different block from the add-to-cart form, so look across the whole section. */
  function tiers(root) {
    $$('.kv [data-tier]', root).forEach(r => {
      if (!once(r, 'kvTier')) return;
      r.addEventListener('change', () => {
        const scope = r.closest('.shopify-section') || document;
        $$('.kv .kp__tier', scope).forEach(l => l.classList.toggle('is-on', l.contains(r)));
        $$('.kv [data-variant-id]', scope).forEach(i => { i.value = r.value; });
      });
    });
    $$('.kv [data-kq]', root).forEach(r => {
      if (!once(r, 'kvKq')) return;
      const scope = r.closest('.shopify-section') || document;
      const apply = () => {
        $$('.kv .kq__t', scope).forEach(l => l.classList.toggle('is-on', l.contains(r)));
        $$('.kv [data-kv-qty]', scope).forEach(i => { i.value = r.value; });
      };
      r.addEventListener('change', apply);
      if (r.checked) apply();
    });
  }

  function videos(root) {
    $$('.kv [data-vids]', root).forEach(el => {
      if (!once(el, 'kvVids')) return;
      const track = $('[data-vids-track]', el), prev = $('[data-vids-prev]', el), next = $('[data-vids-next]', el);
      const step = () => { const c = track.firstElementChild; return c ? c.offsetWidth + 10 : track.clientWidth; };
      const sync = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      track.addEventListener('play', e => $$('video', track).forEach(v => { if (v !== e.target) v.pause(); }), true);
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function addToCart(root) {
    $$('.kv [data-product-form]', root).forEach(form => {
      if (!once(form, 'kvForm')) return;
      form.addEventListener('submit', async e => {
        const scope = form.closest('.shopify-section') || document;
        /* Free gifts unlocked by the chosen pack (Bundle boxes block) go in with the pack */
        const gifts = $$('.kv [data-kvt-gifts] .kvt-gift[data-gift-variant]', scope).filter(g => !g.classList.contains('is-locked')).map(g => String(g.dataset.giftVariant));
        const drawer = document.querySelector('cart-drawer');
        const hasDrawer = !!(drawer && typeof drawer.renderContents === 'function');
        if (!hasDrawer && !gifts.length) return; // normal submit → cart page
        e.preventDefault();
        const err = $('[data-error]', form); if (err) err.hidden = true;
        const btn = $('[data-atc]', form); if (btn) btn.disabled = true;
        try {
          const fd = new FormData(form);
          const main = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
          const props = {};
          for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; }
          /* What's in the chosen pack (Bundle box contents line, e.g. "6 Hook Caps + 3 Lamp Blocks") shows on the cart line, checkout and order */
          const packIn = $('.kv [data-kvt-pack]:checked', scope);
          const packSub = packIn && packIn.nextElementSibling ? $('.kvt__sub', packIn.nextElementSibling) : null;
          if (packSub && packSub.textContent.trim() && String(packIn.dataset.variant) === String(main.id)) props.Includes = packSub.textContent.trim();
          if (Object.keys(props).length) main.properties = props;
          const items = [];
          if (gifts.length) {
            let inCart = [];
            try { const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); inCart = c.items.map(i => String(i.variant_id)); } catch (_) {}
            gifts.filter(g => inCart.indexOf(g) < 0).forEach(g => items.push({ id: g, quantity: 1 }));
          }
          items.push(main); /* last in = shown first in the cart */
          const payload = { items };
          if (hasDrawer) { payload.sections = 'cart-drawer,cart-icon-bubble'; payload.sections_url = window.location.pathname; }
          const r = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          const d = await r.json();
          if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not add to cart');
          if (hasDrawer) drawer.renderContents(d);
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        } catch (x) { if (err) { err.textContent = x.message; err.hidden = false; } }
        finally { if (btn) btn.disabled = false; }
      });
    });
  }

  /* Kaching bars: "$X per bulb" under the price. Quantities come from Kaching's deal data (buy + get, or quantity). */
  var kvBarQty = null;
  function barQuantities() {
    if (kvBarQty) return kvBarQty;
    kvBarQty = {};
    $$('script').some(function (sc) {
      var t = sc.textContent; var i = t.indexOf('"dealBars"');
      if (i < 0) return false;
      t.slice(i).split('{"id":"').slice(1).forEach(function (chunk) {
        var id = chunk.slice(0, chunk.indexOf('"'));
        var end = chunk.indexOf('{"id":"'); var body = end > 0 ? chunk.slice(0, end) : chunk;
        var b = body.match(/"buyQuantity":(\d+)/), g = body.match(/"getQuantity":(\d+)/), q = body.match(/"quantity":(\d+)/);
        var n = b ? parseInt(b[1], 10) + (g ? parseInt(g[1], 10) : 0) : (q ? parseInt(q[1], 10) : 0);
        if (id && n && !kvBarQty[id]) kvBarQty[id] = n;
      });
      return true;
    });
    return kvBarQty;
  }
  function perBulb() {
    var qty = barQuantities();
    $$('.kaching-bundles__bar[data-deal-bar-id]').forEach(function (bar) {
      var n = qty[bar.getAttribute('data-deal-bar-id')];
      var priceEl = $('.kaching-bundles__bar-price', bar);
      var pricing = $('.kaching-bundles__bar-pricing', bar);
      if (!n || !priceEl || !pricing) return;
      var txt = priceEl.textContent.trim();
      var m = txt.match(/[\d.,]+/); if (!m) return;
      var num = parseFloat(m[0].replace(/,/g, '')); if (!num) return;
      var cents = Math.round(num * 100) / n, usd = !!(window.Shopify && Shopify.currency && Shopify.currency.active === 'USD');
      var each = (usd ? Math.floor(cents) : Math.round(cents)) / 100;
      var label = txt.slice(0, m.index) + each.toFixed(2) + txt.slice(m.index + m[0].length) + ' per bulb';
      var el = $('.kv-per-bulb', pricing);
      if (!el) { el = document.createElement('span'); el.className = 'kv-per-bulb'; pricing.appendChild(el); }
      if (el.textContent !== label) el.textContent = label;
    });
  }
  function perBulbWatch() {
    var queued = false;
    var run = function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; perBulb(); }); };
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { var t = list[i].target; if (t.nodeType === 3) t = t.parentNode; if (t && t.closest && t.closest('.kaching-bundles') && !(t.closest('.kv-per-bulb'))) { run(); return; } }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    run();
  }

  /* Bundle boxes: each box picks a Pack value. Click Elixir's hidden Pack button so its picker
     updates the Add to cart variant and URL; without the picker, set the variant directly. */
  function packBoxes(root) {
    $$('.kv [data-kvt-pack]', root).forEach(r => {
      if (!once(r, 'kvtPack')) return;
      r.addEventListener('change', () => {
        if (!r.checked) return;
        const scope = r.closest('.shopify-section') || document;
        const wrap = r.closest('[data-kvt]');
        if (wrap) {
          const idx = $$('[data-kvt-pack]', wrap).indexOf(r) + 1;
          $$('.kvt-gift[data-unlock]', wrap).forEach(g => g.classList.toggle('is-locked', parseInt(g.dataset.unlock, 10) > idx));
        }
        const opt = $$('.simple-variant-picker__radio', scope).find(x => x.value === r.value && x.name !== r.name);
        if (opt) {
          if (!opt.checked) { opt.checked = true; opt.dispatchEvent(new Event('change', { bubbles: true })); }
        } else if (r.dataset.variant) {
          $$('.kv [data-variant-id]', scope).forEach(i => { i.value = r.dataset.variant; });
        }
      });
    });
  }

  /* Bundle boxes follow the colour: when Elixir's colour button changes, show that colour's pack variants (image, price, variant id). */
  function packColour(root) {
    $$('.kv [data-kvt]', root).forEach(w => {
      if (!once(w, 'kvtColour')) return;
      const mapEl = $('[data-kvt-map]', w); if (!mapEl) return;
      let map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
      const scope = w.closest('.shopify-section') || document;
      const sync = colour => {
        $$('[data-kvt-pack]', w).forEach(r => {
          const hit = Object.keys(map).find(id => map[id].c === colour && map[id].p === r.value);
          if (!hit) return;
          const x = map[hit]; r.dataset.variant = hit;
          const box = r.nextElementSibling; if (!box) return;
          const img = $('.kvt__img', box);
          if (img && x.img) { img.removeAttribute('srcset'); img.src = x.img; }
          const pr = $('.kvt__price', box); if (pr) pr.textContent = x.price;
          const cm = $('.kvt__full', box); if (cm && x.cmp) cm.textContent = x.cmp;
        });
      };
      scope.addEventListener('change', e => {
        const t = e.target;
        if (t && t.matches && t.matches('.simple-variant-picker__radio[data-option-position="1"]') && t.checked) sync(t.value);
      });
    });
  }

  /* Gallery thumbnails: round arrows either end of Elixir's thumbnail strip */
  function thumbArrows(root) {
    $$('.shop-thumbnails', root).forEach(strip => {
      if (!once(strip, 'kvThumbs')) return;
      const wrap = strip.parentElement; if (!wrap) return;
      wrap.classList.add('kv-tharrows');
      const mk = (dir) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'kv-tharrow kv-tharrow--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous images' : 'Next images');
        b.innerHTML = dir === 'prev'
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
        wrap.appendChild(b); return b;
      };
      const prev = mk('prev'), next = mk('next');
      const step = () => { const t = strip.querySelector('.shop-thumbnail'); return t ? (t.offsetWidth + 8) * 2 : strip.clientWidth * 0.6; };
      const sync = () => {
        const can = strip.scrollWidth > strip.clientWidth + 2;
        prev.hidden = next.hidden = !can;
        prev.disabled = strip.scrollLeft <= 2;
        next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      };
      prev.addEventListener('click', () => strip.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => strip.scrollBy({ left: step(), behavior: 'smooth' }));
      strip.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      setTimeout(sync, 50); sync();
    });
  }

  function init(root) { tabs(root); gallery(root); tiers(root); videos(root); addToCart(root); packBoxes(root); packColour(root); thumbArrows(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { init(document); perBulbWatch(); });
  else { init(document); perBulbWatch(); }
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
